import React from "react";

const Svg = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
    >
      <path
        d="M8.5 1.20215V4.30005C8.5 4.72009 8.5 4.93011 8.58175 5.09055C8.65365 5.23167 8.76839 5.3464 8.90951 5.41831C9.06994 5.50005 9.27996 5.50005 9.7 5.50005H12.7979M8.5 12.25H4M10 9.25H4M13 6.99117V12.4C13 13.6601 13 14.2902 12.7548 14.7715C12.539 15.1948 12.1948 15.539 11.7715 15.7548C11.2902 16 10.6601 16 9.4 16H4.6C3.33988 16 2.70982 16 2.22852 15.7548C1.80516 15.539 1.46095 15.1948 1.24524 14.7715C1 14.2902 1 13.6601 1 12.4V4.6C1 3.33988 1 2.70982 1.24524 2.22852C1.46095 1.80516 1.80516 1.46095 2.22852 1.24524C2.70982 1 3.33988 1 4.6 1H7.00883C7.55916 1 7.83432 1 8.09327 1.06217C8.32285 1.11729 8.54233 1.2082 8.74364 1.33156C8.9707 1.4707 9.16527 1.66527 9.55442 2.05442L11.9456 4.44558C12.3347 4.83473 12.5293 5.0293 12.6684 5.25636C12.7918 5.45767 12.8827 5.67715 12.9378 5.90673C13 6.16568 13 6.44084 13 6.99117Z"
        stroke="#333333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Svg;
